export default "__VITE_ASSET__723ba157__"